"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (theme) => ({
    maxWidth: 1300,
    marginLeft: 'auto',
    marginRight: 'auto',
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzcG9uc2l2ZVdpZHRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hlbHBlcnMvcmVzcG9uc2l2ZVdpZHRoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBU0Esa0JBQWUsQ0FBQyxLQUFZLEVBQW1CLEVBQUUsQ0FBQyxDQUFDO0lBQ2pELFFBQVEsRUFBRSxJQUFJO0lBQ2QsVUFBVSxFQUFFLE1BQU07SUFDbEIsV0FBVyxFQUFFLE1BQU07Q0FDcEIsQ0FBQyxDQUFDIn0=